// extracted by mini-css-extract-plugin
export default {"popupContent":"CreateGameWordSelectInfoPopup_popupContent__hxmVE","image":"CreateGameWordSelectInfoPopup_image__Ag7b2"};